// extracted by mini-css-extract-plugin
module.exports = {"theme":"credible3a11y_theme__dAlpv"};